// src/components/ui/BaseRadioButton.tsx
import React from "react";

interface BaseRadioButtonProps {
	label: string;
	/** now controlled entirely by `isChecked` */
	isChecked?: boolean;
	onChange: () => void;
	/** all radios in the same group need the same name */
	name?: string;
}

const BaseRadioButton: React.FC<BaseRadioButtonProps> = ({
	label,
	isChecked = false,
	onChange,
	name = "grouping",
}) => {
	return (
		<label className="flex items-center cursor-pointer select-none text-dark dark:text-white ">
			<input
				type="radio"
				name={name}
				checked={isChecked}
				onChange={onChange}
				className="sr-only"
			/>
			<div
				className={`box mr-2 flex h-4 w-4 items-center justify-center rounded-full border ${
					isChecked ? "bg-primary border-primary" : "border-gray-500"
				}`}
			>
				{isChecked && (
					<span className="h-[6px] w-[6px] rounded-full bg-white" />
				)}
			</div>
			<div className="text-black">{label}</div>
		</label>
	);
};

export default BaseRadioButton;
